export const MODULE_IDS = {
  contacts: "WMNeXSrh3zlFzIBCZPAq",
  customers: "WMNeXSrh3zlFzIBCZPAq",
  companies: "WMNeXSrh3zlFzIBCZPAq",
  quotes: "YzeCWO5vQIgYKrdZCuWz",
  invoices: "JAms0PMwguesdZvvXvIL",
  products: "dBNa5WjEnL1tjUJBDVHd",
  logistics: "kEUEhxSoDZWSVjNkGIy7",
  blogs: "zS95PXCJ8QRCXsNgRMSX",
  teams: "GPvYlONpjCDqzW6sckkw",
  projects: "Dk1wdkEvdgyIPmJAg1uv",
  intelligence: "xKtnIntelligenceMod1",
};

export const MODULES = {
  customers: { id: MODULE_IDS.customers, slug: "customers", label: "Clients", icon: "mdi-folder-account", route: "/customers" },
  companies: { id: MODULE_IDS.companies, slug: "companies", label: "Entreprises", icon: "mdi-domain", route: "/companies" },
  quotes: { id: MODULE_IDS.quotes, slug: "quotes", label: "Devis", icon: "mdi-clipboard-multiple-outline", route: "/quotes" },
  invoices: { id: MODULE_IDS.invoices, slug: "invoices", label: "Factures", icon: "mdi-cash-multiple", route: "/invoices" },
  products: { id: MODULE_IDS.products, slug: "products", label: "Produits", icon: "mdi-cube", route: "/products" },
  logistics: { id: MODULE_IDS.logistics, slug: "logistics", label: "Logistique", icon: "mdi-truck-outline", route: "/logistics" },
  blogs: { id: MODULE_IDS.blogs, slug: "blogs", label: "Blogs", icon: "mdi-newspaper", route: "/blogs" },
  teams: { id: MODULE_IDS.teams, slug: "teams", label: "Équipes", icon: "mdi-account-multiple", route: "/team" },
  projects: { id: MODULE_IDS.projects, slug: "projects", label: "Projets", icon: "mdi-folder", route: "/projects" },
};

export function hasModule(modules, slug) {
  const id = MODULE_IDS[slug];
  if (!id) return false;
  return Array.isArray(modules) && modules.some((entry) => entry.id === id);
}
